import React from "react";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";
import TuneIcon from '@mui/icons-material/Tune';
import { tokens } from "../theme";

// The quieter half of a pair: plum on a transparent ground, so it reads as an
// alternative to the primary action rather than a second one competing with it.
const SecondaryBtn = styled(Button)({
  border: `1px solid ${tokens.borderStrong}`,
  color: tokens.primary,
  background: "transparent",
  fontSize: "0.875rem",
  lineHeight: 1.6,
  fontWeight: 600,
  wordWrap: "break-word",
  textAlign: "center",
  textTransform: "none",
  boxShadow: "none",
});

const secondaryHoverSx = {
  "&:hover": { background: "transparent", borderColor: tokens.primary, boxShadow: "none" },
};

const SecondaryButton = (props) => {
  const { onClick: onBtnClick , startIcon: StartIcon, disabled, sx, to} = props;

  const handleOnClick = (e) => {
    e.stopPropagation();
    if (onBtnClick) {
      onBtnClick();
    }
  };
  
  if (to) {
    return (
      <Link to={to} style={{ textDecoration: 'none', color: 'inherit' }}>
        <SecondaryBtn sx={{ ...sx, ...secondaryHoverSx }}>
          {StartIcon && <TuneIcon />}
          {props.children || "default"}
        </SecondaryBtn>
      </Link>
    );
  }

  return (
    <SecondaryBtn onClick={(e) => handleOnClick(e)}
      disabled={disabled}
      sx={{ ...sx, ...secondaryHoverSx }}
      startIcon={StartIcon ? <TuneIcon/> : null}
    >
      {props.children || "default"}
    </SecondaryBtn>
  );
};

export default SecondaryButton;
